import { Helmet } from "react-helmet-async";

const Terms = () => {
  return (
    <main className="container mx-auto py-10 space-y-6">
      <Helmet>
        <title>Terms of Service — U.S. Height Percentiles</title>
        <meta name="description" content="Terms of service. Informational only; not medical advice." />
        <link rel="canonical" href={window.location.origin + "/terms"} />
      </Helmet>
      <h1>Terms of Service</h1>
      <p>
        This website is provided for informational purposes only and does not constitute medical advice. The
        content is offered “as is” without warranties of any kind. By using this site, you agree not to rely on
        the information for diagnosis or treatment and to comply with all applicable laws.
      </p>
      <p className="text-sm text-muted-foreground">© {new Date().getFullYear()} US Height Percentiles</p>
    </main>
  );
};

export default Terms;
